import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class EntryModel extends Model 
{
	@attr bib;
	@attr firstName;
	@attr lastName;
	@attr seedGroup;
	@attr DOB;
	@attr gender;
	@attr town;
	@attr state;
	@attr country;
	@attr club;
	@attr text1;
	@attr text2;
	@attr text3;
	@attr('number',{defaultValue: 0}) id1;
	@attr('number',{defaultValue: 0}) id2;
	@attr('number',{defaultValue: 0}) id3;
	@attr('number',{defaultValue: 0}) pts1;
	@attr('number',{defaultValue: 0}) pts2;
	@attr('number',{defaultValue: 0}) pts3;
	@attr('number',{defaultValue: 0}) pts4;
	@attr('number',{defaultValue: 0}) pts5;
	@attr('number',{defaultValue: 0}) racePts1;
	@attr('number',{defaultValue: 0}) racePts2;
	@attr('number',{defaultValue: 0}) racePts3;
	@attr('number',{defaultValue: 0}) racePts4;
	@attr('number',{defaultValue: 0}) racePts5;
	@attr({defaultValue:'OK'}) status;
	@attr teamOrder;
	
	@belongsTo('event', {inverse:'entries', async: true}) EventId;
	@belongsTo('class', {inverse:'entries', async: true}) ClassId;
	@belongsTo('team', {inverse:'entries', async: true}) TeamId;
	@belongsTo('course', {inverse: null, async: true}) CourseId;
	@belongsTo('start-timing-record', {inverse: 'EntryId', async: true}) StartTimingRecordId;
	@belongsTo('finish-timing-record', {inverse: 'EntryId', async: true}) FinishTimingRecordId;
	@belongsTo('tie-timing-record', {inverse: 'EntryId', async: true}) TieTimingRecordId;
	@hasMany('penalty-timing-record', {inverse: 'EntryId', async: true}) penaltyTimingRecords;
	@hasMany('intermediate-timing-record', {inverse: 'EntryId', async: true}) intermediateTimingRecords;
}